import _ from 'lodash'

export const APIURL = (protocol) => {
	const dev_url = `${protocol || 'http'}://localhost:9000`
	const live_url = `${protocol || 'https'}://api.chessroom.online`

	if (window.location.hostname !== 'localhost') return live_url;
	else return dev_url;
}